import React, { Component } from 'react';
import { Typography, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar, IconButton, Card, Box, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import { CloseRounded, SearchRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { Alert } from '@material-ui/lab';
import IncomeDetails from './IncomeDetails';
import { toast } from 'react-toastify';


class LinkIncome extends Component {
    state = { 
        income: {},
        noMatch: false,
        errors: {
            incomeID: ""
        }
    }
    getIncome = async () => {
        if (this.props.incomeID){
            const res = await this.props.getIncomeInfo(this.props.incomeID)
            console.log('====================================');
            console.log({res});
            console.log('====================================');
            if (!res.error && res.income_amount !== 0) {
                this.setState({
                    income: res,
                    errors: {
                        incomeID: ""
                    }
                })
            } else {
                this.setState({
                    noMatch: true
                })
            }
        } else {
            this.setState({
                errors: {
                    incomeID: "Veuillez remplir ce champ"
                }
            })
        }
    }
    handleChange = (e) => {
        this.setState({ income: {}, noMatch: false })
        this.props.handleChange(e)
    }
    validate = async () => {
        const { income, noMatch } = this.state;
        // if (isEmpty(income)){
        //     await this.getIncome()
        // } 
        if (!isEmpty(income)){

            if (noMatch || isEmpty(this.props.incomeID)){
                toast.error(  "Aucune recette correspond à cet ID")
                return
            }
            // Montants saisis ligne par ligne (pointage partiel) : un montant hors bornes bloque
            // la validation. Les écrans qui ne saisissent pas de montant ne passent pas amountsError.
            if (this.props.amountsError){
                toast.error(this.props.amountsError)
                return
            }
            if (income.income_total_available < this.props.totalPay){
                toast.error( "Montant recette insuffisant ")
            } else {
                this.props.handleSubmitLink(income)
            }
        }

    }
    render() {
        const { totalPay} = this.props;
        const { income, noMatch } = this.state;
        console.log('=================STATE===================');
        console.log(this.state);
        console.log('====================================');
        return (
            <PopUp
                title={this.props.title || "Pointer les paiements "}
                close={this.props.handleClose}
                submitAction={ isEmpty(income) ?  this.getIncome : this.validate}
                submitTitle={isEmpty(income) ? "Rechercher": "Valider"}
                submitColor={isEmpty(income) && "primary" }
                appbar
                // disabledSubmit={isEmpty(this.props.incomeID)}
            >
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="ID Recette 5000"
                            value={this.props.incomeID}
                            required
                            name="incomeID"
                            onChange={this.handleChange}
                            error={this.state.errors.incomeID}
                            endAction={(!isEmpty(this.props.incomeID) &&
                                <IconButton onClick={this.getIncome}>
                                    <SearchRounded color="secondary"/>
                                </IconButton>
                            )}
                        />
                        <Box p={1}>
                            {!noMatch && !isEmpty(income) &&
                                <IncomeDetails income={income} />
                            }
                            {noMatch &&
                                <Alert severity="warning">Recette introuvable</Alert>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <List style={{ maxHeight: "500px", overflow: "auto"}}>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Total</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="h6" color="secondary" >
                                                <Currency value={totalPay} />
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            {this.props.children}
                        </List>
                    </Grid>
                </Grid>
            </PopUp>
        );
    }
}

export default LinkIncome;